import React, { Component } from 'react'

import { Container } from 'components/Layout'
import NumbersCallPlanForm from '../NumbersCallPlanForm'
import HeadingBanner from 'components/Text/HeadingBanner'

import sText from 'components/Text/Text.scss'

export default class NumbersCallPlanModal extends Component {
  render() {
    const { modalConfirm, serviceId, modalCancel } = this.props
    return (
      <div>
        <HeadingBanner filled>
          <h3 className={sText.heading3}>Change Call Plan</h3>
          <div className={sText.descrip2}>Modify call routing and forwarding numbers</div>
        </HeadingBanner>
        <Container paddingTop paddingBottom className="sm">
          <NumbersCallPlanForm
            serviceId={serviceId}
            afterSubmit={modalConfirm}
            onCancel={modalCancel}
          />
        </Container>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersCallPlanModal/NumbersCallPlanModal.jsx